import React from 'react';
import { Header, RouterContext } from '../../gs-component-right-rail';
import styles from './styles.scss';
import { TabViews } from '../interfaces';
import { isKeyEnterSpace } from '../helpers';

interface TabProps {
  active: boolean;
  text: string;
  onClick: (e: any) => void;
}

interface HeaderProps {
  onClose?: () => void;
  showConfirmation: boolean;
  showTabs: boolean;
  currentView?: string;
  setView?: (view: TabViews) => void;
  topLabel?: string;
  goBack?: () => void;
}

export const Tab: React.FC<TabProps> = ({ active, text, onClick }) => {
  const classes = active ? `${styles.tab} ${styles.active}` : styles.tab;

  const keyDownClick = (e: any): void => {
    if (isKeyEnterSpace(e)) onClick(e);
  };

  return (
    <>
      <div
        role="link"
        tabIndex={0}
        className={classes}
        onClick={onClick}
        onKeyDown={keyDownClick}
        title={text}
        data-testid={`Link-${text}`}
      >
        {text}
      </div>
    </>
  );
};

export const GUEST_TAB = 'main';
export const RESPONSES_TAB = 'responses';

const HeaderWithTabs: React.FC<HeaderProps> = ({
  onClose,
  showConfirmation,
  showTabs,
  currentView,
  setView,
  topLabel,
  goBack,
  children,
}) => {
  const { push } = React.useContext(RouterContext);
  const closeRail = (): void => {
    if (!onClose) return;
    if (showConfirmation) {
      push('cancel');
    } else {
      onClose();
    }
  };

  const handleClick = (screen: TabViews): void => {
    if (currentView === screen) return;
    if (showConfirmation) {
      push('switch');
    } else {
      if (push) push(screen);
      if (setView) setView(screen);
    }
  };

  const goBackProps = goBack
    ? {
        leftButtonOnClick: goBack,
        leftButtonText: ' ',
      }
    : {};

  return (
    <Header onClose={closeRail} {...goBackProps}>
      {topLabel && <div className={styles.topLabel}>{topLabel}</div>}
      {children}
      {showTabs && (
        <div className={styles.tabsContainer}>
          <Tab
            active={currentView === GUEST_TAB}
            text="Guest Information"
            onClick={(): void => handleClick(GUEST_TAB)}
          />
          <Tab
            active={currentView === RESPONSES_TAB}
            text="RSVP Responses"
            onClick={(): void => handleClick(RESPONSES_TAB)}
          />
        </div>
      )}
    </Header>
  );
};

export default HeaderWithTabs;
